import { useDashboardStore } from '@/state/store';
import type { ConnectionState } from '@/api/ws';

const COLOR: Record<ConnectionState, string> = {
  idle: '#6e7681',
  connecting: '#d29922',
  open: '#d29922',
  subscribed: '#2ea043',
  reconnecting: '#d29922',
  closed: '#f85149',
};

const LABEL: Record<ConnectionState, string> = {
  idle: 'idle',
  connecting: 'connecting…',
  open: 'open',
  subscribed: 'live',
  reconnecting: 'reconnecting…',
  closed: 'closed',
};

const STATE_TOOLTIP: Record<ConnectionState, string> = {
  idle: 'WebSocket ещё не открыт. Стрим событий пока не подключён.',
  connecting: 'Открываем WebSocket к /api/v1/stream...',
  open: 'WebSocket открыт, но подписка ещё не подтверждена backend\'ом. Ждём первое sub-сообщение.',
  subscribed:
    'WebSocket активен и подписан. Backend стримит события через consumer loop, который читает Redis events:all. Зелёный = всё работает.',
  reconnecting:
    'Соединение упало, пытаемся переподключиться (exponential backoff). При re-connect-е delivery догоняется через backlog replay по since_id.',
  closed:
    'Соединение закрыто и не восстанавливается. Скорее всего backend недоступен или истёк API-токен.',
};

export function ConnectionBadge() {
  const state = useDashboardStore((s) => s.connection);
  const count = useDashboardStore((s) => s.eventsReceived);
  const lastError = useDashboardStore((s) => s.lastError);

  // Compose the badge-level tooltip: state explanation, last error
  // (if any), event count -- so a single hover surfaces everything an
  // operator might want to know about the stream's health.
  const badgeTitle = [
    STATE_TOOLTIP[state],
    lastError ? `Последняя ошибка: ${lastError}` : null,
    `Всего получено событий с момента открытия страницы: ${count}.`,
  ]
    .filter(Boolean)
    .join('\n\n');

  return (
    <div
      title={badgeTitle}
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 8,
        padding: '6px 12px',
        borderRadius: 8,
        background: '#0d1117',
        border: '1px solid #21262d',
        fontSize: 12,
      }}
    >
      <span
        aria-hidden
        style={{
          width: 8,
          height: 8,
          borderRadius: '50%',
          background: COLOR[state],
          boxShadow:
            state === 'subscribed' ? `0 0 8px ${COLOR.subscribed}` : 'none',
        }}
      />
      <span style={{ color: '#e6edf3' }}>{LABEL[state]}</span>
      <span
        style={{ color: '#8b949e', marginLeft: 4 }}
        title="Сколько событий backend прислал в эту WebSocket-сессию (включая backlog при connect'е)."
      >
        {count} ev
      </span>
    </div>
  );
}
